import ContainerAnnotation from '../../model/ContainerAnnotation'

class TestContainerAnnotation extends ContainerAnnotation {}

TestContainerAnnotation.type = 'test-container-anno'

export default TestContainerAnnotation
